module.exports = __webpack_public_path__ + "static/media/61Na4U9J8+L._SL1500_.42fa4c59.jpg";